import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { Container, Modal } from 'tmt-ui-kit';
import styled from 'styled-components';
import { connect } from 'react-redux';
import xss from 'xss';

import { actions as articleActions } from '~/redux/reducers/article';
import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as appActions } from '~/redux/reducers/app';
import { actions as infoActions } from '~/redux/reducers/info';
import { actions as sessionActions } from '~/redux/reducers/session';
import { path } from '~/utils/media';
import { triggerViewManyContent } from '~/utils/data-layer';

import HeadTag from '~/components/Head/HeadTag';
// import BannerTopic from '~/components/Row/Topics/BannerTopic';
import NotFound from '~/components/NotFound/NotFound';
import Topic from '~/components/Topic/Topic';
import { getJsonLds } from '~/utils/google-structured-data';
import { getLandmarkRatingData } from '~/utils/article';
// import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
// import Modal from '~/components/Modal/Modal';
import ShareSocials from '~/components/General/ShareSocials/ShareSocials';
import Rating from '~/components/Article/Rating';

const EBook = dynamic(
  () => import(/* webpackChunkName: "EBook" */'../../components/EBook'),
  { loading: () => null }
);

const BannerTopic = dynamic(
  () => import(/* webpackChunkName: "Topic.BannerTopic.components" */'../../components/Row/Topics/BannerTopic'),
  { loading: () => null }
);

const Breadcrumbs = dynamic(
  () => import(/* webpackChunkName: "Breadcrumbs.Breadcrumbs.components" */'../../components/Breadcrumbs/Breadcrumbs'),
  { loading: () => null }
);

const InnerContainer = styled(Container.InnerContainer)`
  padding-top: 16px;
  margin-bottom: 32px;
  max-width: 1100px;

  p {
    font-family: 'Open Sans', sans-serif;
    a {
      font-family: 'Open Sans', sans-serif;
    }
  }
`;

const Title = styled.h1`
  margin: 0.2em 0;
`;

const FormContainer = styled.div`
  margin-top: 32px;
  text-align: center;
  height: 980px;
`;

const Frame = styled.iframe`
  width: 100%;
  height: 100%;
  border: 0;
  seamless: true;
`;

const enhance = connect(
  state => ({
    article: state.article.article,
    isError: state.article.isError,
    ebooks: state.info.ebooks
  }),
  {
    ...appActions,
    ...articleActions,
    logClickCard: tripActions.logClickCard,
    logImpressCard: tripActions.logImpressCard,
    logImpressTopic: tripActions.logImpressTopic,
    logClickSeeMore: tripActions.logClickSeeMore,
    logScrollEnd: tripActions.logScrollEnd,
    getEbooks: infoActions.getEbooks,
    addToConversionSource: sessionActions.addToConversionSource
  }
);

const breadcrumbsStyle = { width: 'fit-content', paddingTop: 0, marginRight: '10px' };

class Article extends Component {
  static propTypes = {
    isError: PropTypes.bool,
    article: PropTypes.object,
    ebooks: PropTypes.arrayOf(PropTypes.object)
  };

  static async getInitialProps({ store, query, req, res }) {
    const { slug } = query;
    try {
      const data = await store.dispatch(articleActions.getArticle(slug));
      if (!!data.data.partner_image && data.data.partner_color) {
        store.dispatch(appActions.setCustomTheme({ main: data.data.partner_color }));
      }
      if (slug === 'all-article') {
        await store.dispatch(infoActions.getEbooks());
      }

      let qstr = '';
      if (req && req.url && req.url.match(/\?.+/)) {
        qstr = req.url.match(/\?.+/);
      }

      // for redirection
      if (data.data.is_redirect) {
        if (req.url === '/article') {
          res.writeHead(301, { Location: `/article${qstr}` });
        } else res.writeHead(301, { Location: `/article/${data.data.slug}${qstr}` });
        res.end();
      } else if (
        (!!req.url.match(/^\/article\/([\w-%]+)\/?(\?.*)?$/i) && data.data.type !== 'basic')
        || (!!req.url.match(/^\/landmark\/([\w-%]+)\/?(\?.*)?$/i) && data.data.type !== 'landmark')
        || (!!req.url.match(/^\/highlights\/([\w-%]+)\/?(\?.*)?$/i) && data.data.type !== 'highlight')
        || (!!req.url.match(/^\/promotions\/([\w-%]+)\/?(\?.*)?$/i) && data.data.type !== 'promotion')
      ) {
        switch (data.data.type) {
          case 'basic':
            res.writeHead(301, { Location: `/article/${data.data.slug}${qstr}` });
            break;
          case 'landmark':
            res.writeHead(301, { Location: `/landmark/${data.data.slug}${qstr}` });
            break;
          case 'highlight':
            res.writeHead(301, { Location: `/highlights/${data.data.slug}${qstr}` });
            break;
          case 'promotion':
            res.writeHead(301, { Location: `/promotions/${data.data.slug}${qstr}` });
            break;
          default: break;
        }
        res.end();
      }
    } catch (err) {
      if (res) res.statusCode = 404;
    }
    return {};
  }

  constructor(props) {
    super(props);
    this.state = { isOpenShare: false };
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.url.query.slug === 'all-article') {
      return {
        isTripGuide: true
      };
    }
    return {
      isTripGuide: false
    };
  }

  componentDidMount() {
    const { isError, article } = this.props;
    const topics = (article.section_ids || [])
      .filter(topic => topic.contains === 'trips');
    if (!isError && topics.length > 0) {
      const tripIds = topics.reduce(
        (arr, topic) => {
          return [
            ...arr,
            ...topic.trip_ids.map(trip => trip._id),
          ];
        },
        []
      );
      if (tripIds.length > 0) {
        triggerViewManyContent(tripIds, 'Dynamic Remarketing - View Trips in topics');
        // dataLayer().push({
        //   event: 'Dynamic Remarketing - View Trips in topics',
        //   dynamic_remarketing_trip_ids: tripIds,
        //   fbads_event: 'ViewContent',
        //   gads_event: 'view_item_list',
        //   gads_params: tripIds.map(id => ({
        //     id,
        //     google_business_vertical: 'custom',
        //   })),
        //   dynx_itemid: tripIds,
        //   dynx_pagetype: eventMapping.view_item_list,
        // });
      }
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.url.query.slug !== this.props.url.query.slug && this.props.url.query.slug === 'all-article') {
      if (this.props.ebooks && this.props.ebooks.length === 0) {
        await this.props.getEbooks();
      }
    }
  }

  onClickModal = () => {
    this.setState(state => ({ isOpenShare: !state.isOpenShare }));
  }

  // getShouldNotSquareLogo = (slug) => {
  //   if (slug === 'partner-agency-gullivers') return true;
  //   return false;
  // }

  getSpecialStyles = (slug) => {
    if (slug === 'partner-agency-gullivers') {
      return {
        BannerPartnerContainer: 'width: 64%'
      };
    }
    if (['partner-ryt-shopping', 'partner-ryt-foodie', 'partner-ryt-entertainment'].includes(slug)) {
      return {
        BannerPartnerContainer: 'margin-top: -170px; font-weight: 600; width: 22%; height: auto; @media(max-width: 600px) { width: 155px }',
        BannerImage: '@media(max-width: 600px) { object-fit: fill; }',
        Title: '@media(max-width: 600px) { font-size: 28px !important; font-weight: 600 !important; }'
      };
    }
    return {};
  }

  render() {
    const { article, isError, ebooks } = this.props;
    if (isError) return <NotFound />;
    const isPartnerArticle = !!article.partner_image;
    const metaTitle = article.meta_title && article.meta_title.length !== 0
      ? article.meta_title
      : article.title;
    const banner = article.banner_image ? {
      title: article.title,
      image: article.banner_image,
      image_alt: article.banner_image_alt,
      partnerImage: article.partner_image,
      partnerImageAlt: article.partner_image_alt,
      isPartner: isPartnerArticle
    } : null;
    const isMTF = article.slug === 'partner-mtf2018';
    const isSurveyYesForm = article.slug === 'hello-checklist';
    const isSurveyNoForm = article.slug === 'goodbyes-are-not-forever';
    const isTripGuide = article.slug === 'all-article';
    // const notSquareLogo = this.getShouldNotSquareLogo(article.slug);
    const specialStyles = this.getSpecialStyles(article.slug);
    let formLink = '';
    if (isMTF) formLink = 'https://docs.google.com/forms/d/e/1FAIpQLScXkHbPnEAZVi8N5vv14C78TdhiOGs6dpprj8FUG6sMcZ-Opw/viewform?embedded=true';
    if (isSurveyYesForm) formLink = 'https://docs.google.com/forms/d/1TGZi6EeDXnl3z2lA5aeo6tUrNXFiK0rddUOQyViI-Xc/viewform?ts=5b603911&embedded=true';
    if (isSurveyNoForm) formLink = 'https://docs.google.com/forms/d/1qyN6AGd7TNDVSB5RLk4gaEMiwbdevqraM2pTRn4fz3k/viewform?ts=5b603921&embedded=true';

    const { averageRating, ratingCount } = getLandmarkRatingData(article);

    return (
      <div>
        <HeadTag
          title={`${metaTitle} | TakeMeTour`}
          description={article.meta_description}
          keywords={article.meta_keywords}
          image={banner ? path(banner.image) : null}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: xss(JSON.stringify(getJsonLds([
            { key: 'getArticle', param: article },
            ...(article.type === 'landmark' ? [{ key: 'getLandmark', param: article }] : [])
          ])))}}
        />
        {banner && <BannerTopic objects={banner} hideOtherCities isOpen={this.onClickModal} specialStyles={specialStyles} />}
        <InnerContainer>
          {!isPartnerArticle && (
            <Breadcrumbs type="Article" data={article} customStyle={breadcrumbsStyle} />
          )}
          {(article.type === 'landmark' && !!averageRating) && <Rating score={averageRating} count={ratingCount} />}
          {isTripGuide && ebooks && ebooks.length > 0 && <EBook ebooks={ebooks} />}
          {!banner && <Title>{article.title}</Title>}
          {article.section_ids && article.section_ids.map((section, index) => (
            <Topic
              {...this.props}
              key={`section-${index}-${section._id}`}
              topic={section}
            />
          ))}
          {formLink.length > 0 && (
            <FormContainer>
              <Frame src={formLink} >Loading...</Frame>
            </FormContainer>
          )}
        </InnerContainer>
        <Modal.PlainModal isOpen={this.state.isOpenShare} onClose={this.onClickModal}>
          <ShareSocials />
        </Modal.PlainModal>
      </div>
    );
  }
}

export default enhance(Article);
